
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3173)"}},[_c('path',{attrs:{"d":"M21.5 18H21v-.5c0-1.93-1.57-3.5-3.5-3.5h-5v-2h3c1.378 0 2.5-1.122 2.5-2.5v-7C18 1.122 16.878 0 15.5 0h-7A2.503 2.503 0 006 2.5v7C6 10.878 7.122 12 8.5 12h3v2h-5C4.57 14 3 15.57 3 17.5v.5h-.5A2.503 2.503 0 000 20.5v1C0 22.878 1.122 24 2.5 24h2C5.878 24 7 22.878 7 21.5v-1C7 19.122 5.878 18 4.5 18H4v-.5C4 16.122 5.122 15 6.5 15h5v3H11a2.503 2.503 0 00-2.5 2.5v1c0 1.378 1.122 2.5 2.5 2.5h2c1.378 0 2.5-1.122 2.5-2.5v-1c0-1.378-1.122-2.5-2.5-2.5h-.5v-3h5c1.378 0 2.5 1.122 2.5 2.5v.5h-.5a2.503 2.503 0 00-2.5 2.5v1c0 1.378 1.122 2.5 2.5 2.5h2c1.378 0 2.5-1.122 2.5-2.5v-1c0-1.378-1.122-2.5-2.5-2.5zM7 9.5v-7C7 1.673 7.673 1 8.5 1h7c.827 0 1.5.673 1.5 1.5v7c0 .827-.673 1.5-1.5 1.5h-7C7.673 11 7 10.327 7 9.5zm-1 11v1c0 .827-.673 1.5-1.5 1.5h-2c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5zm8.5 0v1c0 .827-.673 1.5-1.5 1.5h-2c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5zm8.5 1c0 .827-.673 1.5-1.5 1.5h-2c-.827 0-1.5-.673-1.5-1.5v-1c0-.827.673-1.5 1.5-1.5h2c.827 0 1.5.673 1.5 1.5v1zm-9-13v-5a.5.5 0 011 0v5a.5.5 0 01-1 0zm-1.677.5a.5.5 0 00.478-.647l-1.518-4.932a.597.597 0 00-1.139-.004L8.592 8.349a.5.5 0 00.954.3l.205-.65h1.896l.199.647a.5.5 0 00.478.353L12.323 9zm-2.258-2l.644-2.045.63 2.045h-1.274z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3173"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    